import { parse } from 'qs';

export default (location) =>
  // eslint-disable-next-line no-underscore-dangle
  (process.env.__WL__ ? parse(location.search.slice(1)) : location.query) || {};
